import PropTypes from 'prop-types';
import * as React from 'react';
import ReactDOM from 'react-dom';
import Button from 'components/ButtonDeprecated';
import Glyph from 'components/Glyph';
import LayerTrigger from 'components/LayerTrigger';
import Hovercard from 'components/Hovercard';
import HovercardBody from 'components/HovercardBody';
import SmartTableFilters from 'components/SmartTableFilters';
import { Filter as SmartTableFilter } from 'components/SmartTable';
import { Filter as FilterOption } from 'reducers/tables';

type Props = {
  filters: SmartTableFilter[];
};

class SmartTableFilterIcon extends React.Component<Props> {
  static contextTypes = {
    namespace: PropTypes.string.isRequired,
  };

  render() {
    const layer = (
      <Hovercard className="SmartTableFilterIcon-card" context={this.context}>
        <HovercardBody>
          <SmartTableFilters
            data-test="table-filters"
            namespace={this.context.namespace}
            filters={this.props.filters}
          />
        </HovercardBody>
      </Hovercard>
    );

    return (
      <LayerTrigger ref="trigger" layer={layer} trigger="click" alignment="left" placement="bottom">
        <Button aria-label="Filter" level="icon" color="graphite" eventElementName="enter_filters">
          <Glyph name="sort" color="graphite" size="large" />
        </Button>
      </LayerTrigger>
    );
  }
}

export default SmartTableFilterIcon;
